import { render, staticRenderFns } from "./TheChart.vue?vue&type=template&id=cd31c984&scoped=true&"
import script from "./TheChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./TheChart.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TheChart.vue?vue&type=style&index=0&id=cd31c984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd31c984",
  null
  
)

export default component.exports